<div class="row d-flex justify-content-end">
    <button mat-button color="primary" (click)="onClose()"><mat-icon>close</mat-icon></button>
</div>

<iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="800px" allow="fullscreen"></iframe>
